import { Edit } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import React from 'react';

const QueryBlock: React.FC<{
	label?: string;
	value: string | React.ReactNode;
	editable?: boolean;
	onEdit?: () => void;
}> = ({ label, value, editable = false, onEdit }) => (
	<Stack direction="column" spacing={1} alignItems="flex-start" justifyContent="flex-start" sx={{
		py: 1.5,
		borderBottom: '1px solid #f1f3f5',
		'&:last-child': { borderBottom: 'none' },
		...(editable && {
			'&:hover': {
                "button": {
                    opacity: 1,
                },
				bgcolor: '#fafbfc',
				mx: -1.5,
				px: 1.5,
				borderRadius: 0.75,
			},
		}),
	}}>
		{label && (
			<Typography
				fontFamily="Lato"
				fontSize="0.9rem"
				color="#6c757d"
				textAlign="left"
				minWidth={70}>
				{label}
			</Typography>
		)}
		<Stack direction="row" spacing="4px" alignItems="flex-start" justifyContent="space-between">
			<Typography
				fontFamily="Lato"
				fontSize="0.9rem"
				color="#2c3e50"
				fontWeight={500}>
				{value}
			</Typography>
			{editable && (
				<IconButton size="small" onClick={onEdit}
                    sx={{ opacity: 0, transition: 'opacity 0.2s'}} >
					<Edit sx={{ fontSize: 14 }} />
				</IconButton>
			)}
		</Stack>
	</Stack>
);

export default QueryBlock;